<template>
  <div id="invoice-list-loading">
    <vs-table :data="invoices">
      <template slot="header">
        <vs-row>
          <vs-col vs-w="3">
            <vs-button
              color="success"
              class="mx-2"
              icon-pack="feather"
              icon="icon-plus"
              @click="openModal"
              v-show="hasPermission(['IU CASH REQUEST EDIT'])"
            >
              {{ $t('new') }} Cash Request
            </vs-button>
          </vs-col>

          <vs-col vs-offset="6" vs-w="3">
            <div class="con-input-search vs-table--search mr-4 pb-4">
              <input
                class="input-search vs-table--search-input"
                type="text"
                v-model="params.search"
                @keyup.enter="search"
              />
              <vs-icon icon="search"></vs-icon>
            </div>
          </vs-col>
        </vs-row>
      </template>
      <template slot="thead">
        <th-sort
          :text="$t('client')"
          column="Cl.ShortName"
          @sort="handleClickSort"
        />
        <th-sort
          :text="`${$t('transaction')} #`"
          column="p.Year,p.Week"
          @sort="handleClickSort"
        />
        <th width="150px" class="text-center">{{ $t('actions') }}</th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <cell-input
            class="text-left"
            :value="data[i].ClientName"
            disabled
            width="45vw"
          />

          <cell-input
            class="text-left"
            :value="
              data[i].WeekInvoice != null
                ? `${data[i].WeekInvoice}-${data[i].PackageNumber}`
                : ''
            "
            disabled
          />

          <cell-action disabled class="text-center" width="25vw">
            <template>
              <div>
                <template v-if="allowEditing">
                  <action-change-hold 
                    :popupTitle="$t('hold')"
                    class="icon-action"
                    :data="data[i]"
                    :tooltipText="$t('hold')"
                  />
                </template>
                <template >
                  <action-show-pdf
                    class="icon-action"
                    :src="data[i].url_file"
                    :title="`${data[i].Year} - ${data[i].Week} | ${data[i].InvoiceId} |`"
                    :tooltipText="$t('show_pdf')"
                    :dataId="data[i].InvoiceId"
                    :getDigizenUrl="data[i].url_file == null ? true:false"
                    :pathToGetDigizenUrl="data[i].url_file == null ? '/invoices/get_digizen_url':''"
                  />
                </template>
                
                <template v-if="allowEditing">
                  <action-send-invoice
                    :popupTitle="$t('resend_invoice')"
                    class="icon-action disabled"
                    :data="data[i]"
                    :tooltipText="$t('resend')"
                    v-if="data[i].hold==0"
                  />
                  <action-regenerate-invoice
                    :popupTitle="$t('regenerate_invoice')"
                    class="icon-action"
                    :data="data[i]"
                    :tooltipText="$t('regenerate')"
                    v-if="data[i].no_sent == '0' || hasRole(['admin'])"
                  />
                  <action-link-to-expense
                    class="icon-action"
                    :popupTitle="$t('link_expenses')"
                    :tooltipText="$t('link_expenses')"
                    :data="data[i]"
                    v-if="data[i].no_sent == '0' || hasRole(['admin'])" 
                  />
                  <action-link-to-payroll
                    class="icon-action"
                    :popupTitle="$t('link_payrolls')"
                    :tooltipText="$t('link_payrolls')"
                    :data="data[i]"
                    @linked="updateRegister"
                    
                  />
                  <!-- v-if="data[i].no_sent == '0' && data[i].payroll_id == null" -->
                  <expense-and-payroll-related
                    module="cash_request"
                    :popupTitle="`${$t('expenses')} ${$t('and')} ${$t(
                      'payroll'
                    )}`"
                    class="icon-action"
                    :data="data[i]"
                    :tooltipText="`${$t('expenses')} ${$t('and')} ${$t(
                      'payroll'
                    )}`"
                  />
                  <!-- <action-exclusive-expense-report
                    :popupTitle="$t('expense_exclusive_report')"
                    class="icon-action"
                    :data="data[i]"
                    :tooltipText="$t('expense_exclusive_report')"
                  /> -->
                </template>
              </div>
            </template>
          </cell-action>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup
      :title="$t('complementary_cash_request')"
      :active.sync="active"
      classContent="popup-custom"
    >
      <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="4"
          vs-lg="4"
        >
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="8"
          vs-lg="8"
        >
          <select
            v-model="compPayroll.client_id"
            class="w-full vs-inputx vs-input--input"
          >
            <option
              v-for="(client, i) in clients"
              :key="i"
              :value="client.ClientId"
            >
              {{ client.ClientName }}
            </option>
          </select>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" vs-align="center" vs-w="12" class="mb-2">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="4"
          vs-lg="4"
        >
          <label>{{ $t('period') }}</label>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="8"
          vs-lg="8"
        >
          <select
            v-model="compPayroll.period_id"
            class="w-full vs-inputx vs-input--input"
          >
            <option
              v-for="(period, i) in periods"
              :key="i"
              :value="period.PeriodId"
            >
              {{ period.WeekInvoice }}
            </option>
          </select>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="8"
          vs-lg="8"
        >
          <vs-checkbox v-model="compPayroll.checkBoxValue">{{
            $t('includes_expense')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="flex-end" vs-align="center" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="2"
          vs-lg="2"
        >
          <vs-button
            color="primary"
            type="border"
            :disabled="!isFormValid"
            @click="confirmActive = true"
            class="w-full"
            >{{ $t('create') }}</vs-button
          >
        </vs-col>
      </vs-row>

      <vs-popup :title="$t('confirm')" :active.sync="confirmActive">
        <div class="popup-qb">
          <p>{{ $t('are_you_sure') }}</p>
          <vs-row
            vs-align="center"
            vs-type="flex"
            vs-justify="center"
            class="mt-4"
          >
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
              class="mt-2 px-2"
            >
              <vs-button
                ref="loadableButton"
                id="link-button-loading"
                class="w-full vs-con-loading__container"
                color="primary"
                type="filled"
                :disabled="
                  submitButtonText != $i18n.messages[$i18n.locale].i_am_sure
                "
                @click="submitComplementaryPayroll"
                >{{ submitButtonText }}</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="6"
              class="mt-2 px-2"
            >
              <vs-button
                color="primary"
                type="border"
                class="w-full"
                :disabled="
                  submitButtonText != $i18n.messages[$i18n.locale].i_am_sure
                "
                @click="confirmActive = false"
                >{{ $t('cancel') }}</vs-button
              >
            </vs-col>
          </vs-row>
        </div>
      </vs-popup>
    </vs-popup>
  </div>
</template>

<script>
import CellInput from '@/components/cell-edit/CellInput.vue'
import CellAction from '@/components/cell-edit/CellAction.vue'
import ActionShowPdf from '@/views/components/actions/ActionShowPdf.vue'
import ActionRegenerateInvoice from '@/views/apps/cash_request/components/ActionRegenerateInvoice.vue'
import ActionSendInvoice from '@/views/apps/cash_request/components/ActionSendInvoice.vue'
import ActionLinkToExpense from '@/views/apps/cash_request/components/ActionLinkToExpense.vue'
import ActionLinkToPayroll from '@/views/apps/cash_request/components/ActionLinkToPayroll.vue'
import ThSort from '@/views/components/ThSort.vue'
import ExpenseAndPayrollRelated from '@/views/apps/accounting/components/ExpenseAndPayrollRelated'
import ActionExclusiveExpenseReport from '@/views/apps/cash_request/components/ActionExclusiveExpenseReport'
import ActionChangeHold from '@/views/apps/cash_request/components/ActionChangeHold'

import invoice from '@/http/requests/invoice'

export default {
  components: {
    CellInput,
    CellAction,
    ActionRegenerateInvoice,
    ActionSendInvoice,
    ActionShowPdf,
    ThSort,
    ActionLinkToExpense,
    ActionLinkToPayroll,
    ExpenseAndPayrollRelated,
    ActionChangeHold,
    ActionExclusiveExpenseReport
  },
  props: {
    reSearch: {
      type: Number,
      default: 0
    },
    ClientId: {
      type: Array,
      default: []
    },
    PeriodId: {
      type: Array,
      default: []
    },
    clients: {
      type: Array,
      default: () => { }
    },
    periods: {
      type: Array,
      default: () => { }
    }
  },
  data() {
    return {
      allowEditing: false,
      lastPage: 1,
      params: {
        types: [1],
        page: 1,
        search: '',
        sortBy: ['Invoices.PeriodId'],
        sort: ['desc'],
        ClientId: this.ClientId,
        PeriodId: this.PeriodId
      },
      active: false,
      confirmActive: false,
      compPayroll: {
        client_id: null,
        period_id: null,
        checkBoxValue: false
      },
      submitButtonText: this.$i18n.messages[this.$i18n.locale].i_am_sure
    }
  },
  watch: {
    reSearch() {
      this.params.ClientId = this.ClientId
      this.params.PeriodId = this.PeriodId
      this.search()
    }
  },
  mounted() {
    this.allowEditing = this.hasPermission(['IU CASH REQUEST EDIT'])
    this.init()
  },
  computed: {
    invoices() {
      return this.$store.state.invoice.invoiceList
    },
    isFormValid() {
      return (this.compPayroll.client_id !== null && this.compPayroll.period_id !== null)
    },
  },
  methods: {
    init() {
      this.search()
    },
    search() {
      this.params.page = 1
      for (var propName in this.params) {
        if (this.params[propName] === null || this.params[propName] === undefined || this.params[propName].length === 0) {
          delete this.params[propName];
        }
      }
      //revisar despues
      this.getInvoiceList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    getInvoiceList: function () {
      this.openLoading()
      return this.$store.dispatch('invoice/fetchInvoiceList', this.params).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getInvoiceList()
        .then(res => { this.closeLoading() })
        .catch(err => { this.closeLoading() })
    },
    handleClickSort(e) {
      this.params.sort = e.sort
      this.params.sortBy = e.sortBy
      this.search()
    },
    openLoading() {
      this.$vs.loading({
        container: '#invoice-list-loading',
        scale: 0.6
      })
    },
    closeLoading: function () {
      this.$vs.loading.close('#invoice-list-loading > .con-vs-loading')
    },
    openModal() {
      this.active = true
    },
    submitComplementaryPayroll() {
      this.submitButtonText = this.$i18n.messages[this.$i18n.locale].loading + '...'
      invoice.addComplementaryPayroll(this.compPayroll).then(res => {
        this.$vs.notify({
          color: 'success',
          title: 'Success',
          text: this.$i18n.messages[this.$i18n.locale].payroll_added
        })
        this.confirmActive = false
        this.active = false
        this.submitButtonText = this.$i18n.messages[this.$i18n.locale].i_am_sure
      }).catch(err => {
        console.log(err)
        this.$vs.notify({
          color: 'danger',
          title: 'Oops...',
          text: 'Something went wrong'
        })
      })
    },
    updateRegister(data) {
      //llamar metodo vuex
      const i = this.invoices.findIndex((e) => e.InvoiceId === data.invoiceId)
      this.invoices[i].payroll_id = data.payrollIds[0]
    }
  },
}
</script>

<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope='row']) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.vx-card__body {
  padding: 10px 0px !important;
}

.vs-table--not-data {
  display: none !important;
}

.sm-size {
  font-size: 12px;
}

.comment-truncate {
  overflow-wrap: break-word;
}
.vx-card__title h4 {
  margin-bottom: 2vh;
}
.icon-action {
  display: inline-block;
}

.con-input-search {
  top: -10px;
}

.con-vs-popup .vs-popup {
  top: 30px;
  position: absolute;
}
.popup-qb {
  top: 100px;
  height: 130px;
}
</style>